import React, { Component } from "react";
import "../Common/Common.css";
import ExpiryReturnsView from "./ExpiryReturnsView";
import AddPurchaseReturns from "./AddPurchaseReturns";
import AddReturnOrderDrawer from "../Common/AddReturnOrderDrawer";
import { Table, Card, Row, Col, Image, Button } from "react-bootstrap";
import ReactPaginate from "react-paginate";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

var dateFormat = require("dateformat");

class ExpiryReturns extends Component {
  constructor(props) {
    super(props);
    this.paginationreset = React.createRef();
    this.state = {
      showPurchaseReturnsModal: false,
      PurchaseReturnstoSearch: "",
      returnfilter: "",
      showCreditNotesAddModel: false,
      PurchaseReturnsToShow: [],
      CreditNotesdtList: "",
      page: 0,
      perPage: 10,
      isAddReturnDrawerOpen: false,
    };
  }

  componentDidMount() {
    this.props.fetchExpiryReturns({
      page: undefined,
      filter: this.state.returnfilter,
      searchquery: this.state.PurchaseReturnstoSearch,
    });
  }

  handleAddCreditNotes = (item) => {
    this.setState({
      showCreditNotesAddModel: true,
      CreditNotesdtList: item,
    });
  };

  closeAddCreditNotesModel = () => {
    this.setState({
      showCreditNotesAddModel: false,
    });
  };

  showPurchaseReturnsDetail = (item) => {
    this.setState(
      {
        showPurchaseReturnsModal: true,
        PurchaseReturnsToShow: item,
      },
      () => {
        this.props.ExpiryReturnview({
          item: this.state.PurchaseReturnsToShow,
          page: undefined,
        });
      }
    );
  };

  closePurchaseReturnsModal = () => {
    this.setState({
      showPurchaseReturnsModal: false,
    });
    this.paginationreset.current?.resetitemPage?.();
  };

  handlePageClick = (e) => {
    const selectedPage = e.selected;

    this.props.pageSelected({
      page: selectedPage + 1,
      filter: this.state.returnfilter,
      searchquery: this.state.PurchaseReturnstoSearch,
    });

    this.setState({ page: selectedPage });
  };

  searchPurchaseReturns = (event) => {
    this.setState(
      {
        PurchaseReturnstoSearch: event.target.value,
        returnfilter: "",
        page: 0,
      },
      () => {
        this.props.fetchExpiryReturns({
          page: undefined,
          filter: this.state.returnfilter,
          searchquery: this.state.PurchaseReturnstoSearch,
        });
      }
    );
  };

  returnfilterChange = (event) => {
    this.setState(
      {
        page: 0,
        PurchaseReturnstoSearch: "",
        returnfilter: event.target.value,
      },
      () => {
        this.props.fetchExpiryReturns({
          page: undefined,
          searchquery: this.state.PurchaseReturnstoSearch,
          filter: this.state.returnfilter,
        });
      }
    );
  };

  renderTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>
  );

  addcreditTooltip = (props) => (
    <Tooltip id="button-tooltip" {...props}>
      Add Credit Note
    </Tooltip>
  );

  handleCreateReturn = () => {
    this.setState({ isAddReturnDrawerOpen: true });
  };

  closeAddReturnDrawer = () => {
    this.setState({ isAddReturnDrawerOpen: false });
  };

  handleReturnSuccess = () => {
    this.props.fetchExpiryReturns({
      page: undefined,
      filter: this.state.returnfilter,
      searchquery: this.state.PurchaseReturnstoSearch,
    });
  };

  render() {
    const {
      ExpiryReturnsDetails,
      ExpiryReturnsCount,
      ExpiryReturnDtls,
      ItemCount,
      itempageSelected,
      pdfreturnFullData,
      returnaccept,
      returnrejected,
      returnacceptOne,
      returnrejectedOne,
      updatePurchaseOrderTotals,
    } = this.props;

    const {
      page,
      perPage,
      PurchaseReturnstoSearch,
      showPurchaseReturnsModal,
      PurchaseReturnsToShow,
      returnfilter,
    } = this.state;

    const count = ExpiryReturnsCount;
    let p = page + 1;
    let pageCount = Math.ceil(count / perPage);
    const latestPurchaseReturnToShow =
      showPurchaseReturnsModal &&
      PurchaseReturnsToShow?.item &&
      Array.isArray(ExpiryReturnsDetails)
        ? {
            item:
              ExpiryReturnsDetails.find(
                (item) => item.id === PurchaseReturnsToShow.item.id
              ) || PurchaseReturnsToShow.item,
          }
        : PurchaseReturnsToShow;

    return (
      <div className="salesreturndiv">
        <Card>
          <div className="salesheader">
            <Row>
              <Col md={3}>
                <h5 className="tablecardtitle">Expiry Returns</h5>
              </Col>
              <Col md={2}>
                <Button variant="primary" onClick={this.handleCreateReturn}>
                  <i className="fa fa-plus" style={{ marginRight: "8px" }}></i>
                  Create
                </Button>
              </Col>

              <Col md={2}>
                <div className="commonInputdiv">
                  <div className="commonInput">
                    <i className="fa fa-search fa-lg cmnSearchIcon" />
                    <input
                      type="text"
                      placeholder="Search..."
                      value={PurchaseReturnstoSearch}
                      onChange={this.searchPurchaseReturns}
                    />
                  </div>
                </div>
              </Col>

              <Col md={2}>
                <div className="commonFilterDiv">
                  <select
                    value={returnfilter}
                    onChange={this.returnfilterChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    <option value="created">Created</option>
                    <option value="accepted">Accepted</option>
                    <option value="cancelled">Cancelled</option>
                    <option value="pending">Pending</option>
                    <option value="rejected">Rejected</option>
                  </select>
                </div>
              </Col>

              <Col md={3}>
                <div className="salescommonRecrd">
                  <i className="cui-note icons cmnRecordIcon" />
                  <span className="cmnPageCount">
                    {count !== undefined ? count : 0}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </div>

          <Card.Body className="tableCardBody">
            <Table hover responsive>
              <thead className="tablecommonCard">
                <tr>
                  <th>#</th>
                  <th>Return ID</th>
                  <th>Organization Name</th>
                  <th>Claim Amount</th>
                  <th>Approved Amount</th>
                  <th>Created Date</th>
                  <th>Status</th>
                  <th>Action</th>
                </tr>
              </thead>

              <tbody className="tableBody">
                {ExpiryReturnsDetails &&
                  ExpiryReturnsDetails.map((item, i) => (
                    <tr key={i}>
                      <th scope="row">{10 * (p - 1) + i + 1}</th>

                      <td className="cmn_Cap">
                        {item?.orderNo || "-"}
                      </td>

                      <td className="cmn_Cap">
                        {item?.chmstDtls?.name || "-"}
                      </td>

                      <td className="cmn_Cap">
                        {item?.totalClaimAmount}
                      </td>

                      <td className="cmn_Cap">
                        {item?.totalApprovedAmount || 0}
                      </td>

                      <td className="cmn_Cap">
                        {item?.createdAt
                          ? dateFormat(item.createdAt, "dd-mmm-yyyy")
                          : "-"}
                      </td>

                      <td className="cmn_Cap">
                        {item?.status === "created" ? (
                          <span className="badge badge-primary">
                            {item.status}
                          </span>
                        ) : item?.status === "accepted" ? (
                          <span className="badge badge-success">
                            {item.status}
                          </span>
                        ) : item?.status === "pending" ? (
                          <span className="badge badge-warning">
                            {item.status}
                          </span>
                        ) : (
                          <span className="badge badge-danger">
                            {item?.status || "-"}
                          </span>
                        )}
                      </td>

                      <td className="cmnViewIcon">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          <OverlayTrigger
                            placement="bottom"
                            delay={{ show: 250, hide: 400 }}
                            overlay={this.renderTooltip}
                          >
                            <i
                              className="fa fa-eye fa-lg"
                              onClick={() =>
                                this.showPurchaseReturnsDetail({ item })
                              }
                            />
                          </OverlayTrigger>

                          {item !== null &&
                          item.status === "accepted" &&
                          item.hasCreated === false ? (
                            <OverlayTrigger
                              placement="bottom"
                              delay={{ show: 250, hide: 400 }}
                              overlay={this.addcreditTooltip}
                            >
                              <i
                                className="fa fa-upload"
                                style={{
                                  paddingLeft: 10,
                                  fontSize: "15px",
                                }}
                                onClick={() => this.handleAddCreditNotes(item)}
                              />
                            </OverlayTrigger>
                          ) : null}
                        </div>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>

            <ExpiryReturnsView
              ref={this.paginationreset}
              show={showPurchaseReturnsModal}
              close={this.closePurchaseReturnsModal}
              PurchaseReturnsToShow={latestPurchaseReturnToShow}
              ProductReturnDtls={ExpiryReturnDtls}
              ItemCount={ItemCount}
              itempageSelected={itempageSelected}
              pdfreturnFullData={pdfreturnFullData}
              returnaccept={returnaccept}
              returnrejected={returnrejected}
              returnacceptOne={returnacceptOne}
              returnrejectedOne={returnrejectedOne}
              updatePurchaseOrderTotals={updatePurchaseOrderTotals}
            />
            <AddReturnOrderDrawer
              show={this.state.isAddReturnDrawerOpen}
              onClose={this.closeAddReturnDrawer}
              onSuccess={this.handleReturnSuccess}
              returnType="expiryReturn"
            />
            <AddPurchaseReturns
              showCreditNotesAddModel={this.state.showCreditNotesAddModel}
              closeAddCreditNotesModel={this.closeAddCreditNotesModel}
              CreditNotesdtList={this.state.CreditNotesdtList}
              CreditNotesAdd={this.props.CreditNotesAdd}
            />

            {(ExpiryReturnsDetails === undefined ||
              (ExpiryReturnsDetails && ExpiryReturnsCount === 0)) && (
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require("../../assets/img/nodata4.png")}
                    />
                  </div>
                  <div className="noDataTextDiv">
                    No Expiry Returns Found
                  </div>
                </div>
              )}
          </Card.Body>

          {pageCount > 1 && (
            <div className="paginationDiv">
              <ReactPaginate
                forcePage={this.state.page}
                previousLabel={"Prev"}
                nextLabel={"Next"}
                breakLabel={"..."}
                pageCount={pageCount}
                marginPagesDisplayed={2}
                pageRangeDisplayed={5}
                onPageChange={this.handlePageClick}
                containerClassName={"pagination flex-wrap"}
                activeClassName={"active"}
              />
            </div>
          )}
        </Card>
      </div>
    );
  }
}

export default ExpiryReturns;
